/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import action from './action';

// Components
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';

const __vue_script__ = {
    name: 'EmailingExportLogs',

    components: {
        LoaderButton
    },

    mixins: [action],

    data() {
        return {
            retry: 0,
            jobStatus: {
                status: '',
                timestamp: '',
                progress: 0,
                filePath: ''
            }
        };
    },

    computed: {
        showMessage() {
            return ['done', 'in_progress', 'no_attachment'].includes(this.status);
        },

        running() {
            return this.status === 'in_progress';
        },

        status() {
            return this.jobStatus.status;
        },

        downloadPath() {
            if (this.status !== 'done') {
                return null;
            }

            return this.jobStatus.filePath;
        }
    },

    async created() {
        await this.updateStatus();
    },

    methods: {
        async updateStatus() {
            try {
                const { xls } = await this.$services.appScripts.callAppScript(this.event._id, 'mail/get-background-task-status');
                this.jobStatus = xls;

                if (this.status === 'no_attachment' && this.retry < 5) {
                    setTimeout(async () => {
                        await this.updateStatus();
                        this.retry++;
                    }, 5000);
                } else {
                    this.retry = 0;
                }

            } catch (error) {
                console.error('[EmailingExportLogs] Could not update status:', error);
            }
        },

        onExportClick() {
            requestAnimationFrame(async () => {
                try {
                    this.jobStatus.status = 'in_progress';
                    this.jobStatus.timestamp = Date.now();
                    await this.$services.appScripts.createJobAndWaitForCompletion(this.event._id, 'mail/excel', {
                        filename: 'mail_log.xlsx',
                    }, {
                        name: 'Generate Mail Log XLS',
                    }, 5000, 2);
                } catch (error) {
                    console.error('[EmailingExportLogs] Could not start export:', error);
                } finally {
                    await this.updateStatus();
                }
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emailing-export-logs"},[_c('loader-button',{staticClass:"btn btn-default",attrs:{"status":_vm.running,"disabled":_vm.running,"type":"button"},on:{"click":function($event){return _vm.onExportClick()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.generate_xls')))]),(_vm.showMessage)?_c('div',{staticClass:"message"},[(_vm.running)?[_vm._v(_vm._s(_vm.$t('listings.actions.generating'))),(_vm.jobStatus.timestamp && _vm.status !== 'no_attachment')?[_vm._v(" "+_vm._s(_vm.$t('listings.actions.generation_started', [_vm.$utils.time.timeFromNow(_vm.jobStatus.timestamp)]))+".")]:_vm._e(),(_vm.jobStatus.progress)?[_vm._v(" "+_vm._s(_vm.$t('listings.actions.generation_progress', [_vm.jobStatus.progress]))+".")]:_vm._e()]:(_vm.status === 'done')?[_vm._v(_vm._s(_vm.$t('listings.actions.generation_done', [_vm.$utils.time.timeFromNow(_vm.jobStatus.timestamp)]))+"."),(_vm.downloadPath)?_c('a',{staticClass:"download",attrs:{"href":_vm.downloadPath,"target":"_blank","download":"download"}},[_vm._v(_vm._s(_vm.$t('general.download'))),_c('i',{staticClass:"ic-download"})]):_vm._e()]:(_vm.status === 'no_attachment')?[_vm._v(_vm._s(_vm.$t('listings.actions.attaching_xls')))]:_vm._e()],2):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EmailingExportLogs.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__